export default __webpack_public_path__ + "static/media/Banner_priv.f8dbfb89.jpg";